import { useTranslation } from "react-i18next";

export default function AccountingServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      icon: "ri-book-2-line",
      titleKey: "acct_s1_title",
      descKey: "acct_s1_desc",
      items: ["acct_s1_i1", "acct_s1_i2", "acct_s1_i3", "acct_s1_i4"],
    },
    {
      icon: "ri-bar-chart-2-line",
      titleKey: "acct_s2_title",
      descKey: "acct_s2_desc",
      items: ["acct_s2_i1", "acct_s2_i2", "acct_s2_i3", "acct_s2_i4"],
    },
    {
      icon: "ri-audit-line",
      titleKey: "acct_s3_title",
      descKey: "acct_s3_desc",
      items: ["acct_s3_i1", "acct_s3_i2", "acct_s3_i3", "acct_s3_i4"],
    },
    {
      icon: "ri-building-line",
      titleKey: "acct_s4_title",
      descKey: "acct_s4_desc",
      items: ["acct_s4_i1", "acct_s4_i2", "acct_s4_i3", "acct_s4_i4"],
    },
  ];

  return (
    <section id="accounting-services" className="py-24 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-[#D4927A] text-sm font-semibold tracking-widest uppercase">{t("acct_tag")}</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1C2331] mt-2 leading-tight">
              {t("acct_heading")}
            </h2>
            <p className="text-[#6B7280] mt-3 max-w-lg text-sm leading-relaxed">
              {t("acct_desc")}
            </p>
          </div>
          <div className="w-16 h-px bg-[#D4927A]" />
        </div>

        {/* Image + cards grid */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          {/* Image */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden h-[400px] lg:h-full min-h-[320px]">
            <img
              src="https://public.readdy.ai/ai/img_res/178df1f0924b1aec3b2d22721a1a9282.jpg"
              alt="Accounting Services"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Service cards */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {services.map((service) => (
              <div
                key={service.titleKey}
                className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-[#D4927A]/30 hover:shadow-md transition-all duration-300 group cursor-pointer"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#FAE8DF] group-hover:bg-[#D4927A] transition-colors mb-4">
                  <i className={`${service.icon} text-xl text-[#D4927A] group-hover:text-white transition-colors`} />
                </div>
                <h3 className="font-bold text-[#1C2331] text-base mb-2">{t(service.titleKey)}</h3>
                <p className="text-[#6B7280] text-xs leading-relaxed mb-3">{t(service.descKey)}</p>
                <ul className="space-y-1.5">
                  {service.items.map((itemKey) => (
                    <li key={itemKey} className="flex items-start gap-2 text-xs text-[#4A4A4A]">
                      <i className="ri-checkbox-circle-fill text-[#D4927A] mt-0.5 flex-shrink-0" />
                      {t(itemKey)}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
